module.exports = __webpack_public_path__ + "img/dl3dvn-currency-guide-1.0c7dc8c6.png";